import { TMetaPrimitives } from '@cian/logger/shared';
import {
  fetchPublishProject,
  TPublishProjectResponse,
  TPublishProjectRequest,
} from 'shared/repositories/promotions-flow-control/v1/publish-project';

import { IApplicationContext } from 'shared/types/applicationContext';

export type { TPublishProjectRequest };

export async function publishProject(
  { logger, httpApi }: IApplicationContext,
  parameters: TPublishProjectRequest,
): Promise<boolean> {
  try {
    const result: TPublishProjectResponse = await fetchPublishProject({ httpApi, parameters });

    if (result.statusCode !== 200) {
      logger.warning(result.response.message || /* istanbul ignore next */ 'Код ответа не 200', {
        domain: 'src/shared/services/publishProject.ts [publishProject]',
        message: 'Не удалось опубликовать проект',
        errors: result.response.errors as unknown as TMetaPrimitives[],
      });

      return false;
    }

    return true;
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/publishProject.ts [publishProject]',
      message: 'Не удалось опубликовать проект',
    });

    throw error;
  }
}
